exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/angular/DineroAgil/src/app/starter/starter-left-side/starter-left-side.component.css
// module id = ../../../../../src/app/starter/starter-left-side/starter-left-side.component.css
// module chunks = main